var exports = {
  "Zp": "Card__a0jdaD",
  "F9": "embedded__F5GbPi",
  "Y9": "Header__s3f-F9",
  "HM": "HeaderText__1XQDwm",
  "hE": "Title__InVWlF",
  "Pd": "Subtitle__ylZ_Py",
  "lX": "HeaderActions__7Ov29H",
  "eP": "CollapseButton__euFk-5",
  "FK": "ScrollArea__soqTm4",
  "ct": "GradientTop__NslNGA",
  "Ic": "GradientBottom__TlcztZ",
  "y0": "PreviewContent__QulK_4",
  "X4": "ChildrenContent__7mRleP",
  "wi": "Footer__YFDzuU",
  "GS": "footerBorder__aKnS4I",
  "bq": "FooterButtons__K40aNQ",
};

module.exports = exports;
